import * as Api from '../../api/api';

import * as AdminApiRoutes from '../util/admin-api-routes';

export const getNewOrgLogoPolicy = (orgKey: string) =>
  Api.get(`${AdminApiRoutes.ADMIN_API_BASE_ROUTE}${AdminApiRoutes.getNewOrgLogoPolicy(orgKey)}`);

export const addJobSource = (jobId: number, source: string, extraDetail?: Record<string, any>) =>
  Api.post(
    `${AdminApiRoutes.ADMIN_API_BASE_ROUTE}${AdminApiRoutes.addJobSourceRoute(jobId, source)}`,
    {
      body: JSON.stringify(extraDetail),
    },
  );

export const sendJobsToIndeed = (orgId: number | null, sendJobs: boolean) =>
  Api.post(
    `${AdminApiRoutes.ADMIN_API_BASE_ROUTE}${AdminApiRoutes.adminSendJobsToIndeedRoute(orgId)}`,
    {
      body: JSON.stringify({
        sendJobs,
      }),
    },
  );

export const getApplicationSourceLogsOnDate = (date: string) =>
  Api.get(AdminApiRoutes.accountScoreGenerationLogsForDate(date));
